import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import XLSX from 'sheetjs-style';
import { jsPDF as JSPDF } from 'jspdf';
import 'jspdf-autotable';
import { toast } from 'react-toastify';
import Layout from './DashboardLayout';
import { sToHMSColonSeparated, getUserData } from '../helpers';
import {
  PAGINATION_LIMIT,
  LOCAL_STORAGE_TEAM_OWNER,
  NO_DATA,
  LOCAL_STORAGE_USER_DATA,
} from '../constants';
import { teamService, reportService, clientsService } from '../services';
import Loading from '../components/Loader';
import {
  StatusDropdown,
  TimeZoneDropdown,
  MemberMultiSelectDropdown,
  MultiSelectItemDropdown,
} from '../components/common';
import AdherenceDataTable from '../components/reports/AdherenceDataTable';
import Tardy from '../components/reports/Tardy';

class MemberLiveActivity extends Component {
  state = {
    isLoading: false,
    isUpdatingProjectsList: false,
    isUpdatingTeamsList: false,
    isUpdatingClientsList: false,
    teamMembersList: [],
    teamGroupList: [],
    startDate: moment().startOf('day'),
    endDate: moment().endOf('day'),
    activityMetadata: {},
    numberOfDaysSelected: 1,
    daysLimit: 31,
    page: 1,
    limit: PAGINATION_LIMIT,
    selectedTeamMember: 'all',
    status: [],
    project: [],
    site: [],
    clientId: [],
    siteDropdownState: [],
    projectsList: [],
    activityData: [],
    totalRows: 0,
    initLoad: true,
    timeZone: getUserData('timeZone') || '',
    clientsData: [],
    changeSource: null,
  };

  liveActivityFormRef = React.createRef();

  memberSelectInputRef = React.createRef();

  projectSelectInputRef = React.createRef();

  clientSelectInputRef = React.createRef();

  siteSelectInputRef = React.createRef();

  pageHeading = {
    preTitle: 'Reports',
    title: 'Adherence Report',
  };

  componentDidMount() {
    const { timeZone } = this.state;
    this.getClientData();
    this.getMembersAndProjects();
    this.handleGenerateData({
      timeZone,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { changeSource } = this.state;

    // Only act if changeSource has changed
    if (!changeSource || changeSource === prevState.changeSource) return;

    const formik = this.liveActivityFormRef.current;
    const memberSelect = this.memberSelectInputRef?.current?.select;
    const clientSelect = this.clientSelectInputRef?.current?.select;
    const projectSelect = this.projectSelectInputRef?.current?.select;

    const clearSelect = (selectRef) => selectRef?.clearValue();
    const resetFields = (fields) =>
      fields.forEach((f) => formik.setFieldValue(f, []));

    switch (changeSource) {
      case 'site':
        resetFields(['clientId', 'project', 'selectedTeamMember']);
        [memberSelect, clientSelect, projectSelect].forEach(clearSelect);
        this.getClientData();
        setTimeout(() => {
          this.getMembersAndProjects();
        }, 200);
        break;

      case 'client':
        resetFields(['selectedTeamMember', 'project']);
        [memberSelect, projectSelect].forEach(clearSelect);
        this.getMembersAndProjects();
        break;

      case 'project':
        resetFields(['selectedTeamMember']);
        clearSelect(memberSelect);
        this.getMembersWithProject();
        break;

      default:
        break;
    }

    // Reset changeSource after handling to prevent re-trigger
    this.setState({ changeSource: null });
  }

  handleTardyRequest = (param) => {
    this.setState({ isLoading: true });
    const { activityData } = this.state;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      ...param,
    };
    reportService
      .send_tardy_request(params)
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data[0] &&
          response.data[0].logs &&
          response.data[0].logs[0]
        ) {
          toast.success(NO_DATA.TARDY_REQUEST);
          const userdata = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_USER_DATA)
          );
          response.data[0].logs[0].updatedUserName =
            userdata.firstName + (userdata.lastName || '');
          const getIndex = activityData.findIndex(
            (item) => item._id === param.scheduleId
          );

          activityData[getIndex].activityData.tardyStatus =
            response.data[0].status;
          activityData[getIndex].activityData.tardyLogs = response.data[0].logs;
          activityData[getIndex].activityData.tardyId = response.data[0]._id;

          this.setState({
            activityData,
          });
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleTardyApproval = (param) => {
    this.setState({ isLoading: true });
    const { activityData } = this.state;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      tardyId: param.data?.activityData?.tardyId,
      status: param.status.toLowerCase(),
      note: param.data?.activityData?.tardyLogs[0]?.note || '',
    };

    reportService
      .update_tardy_request(params)
      .then((response) => {
        if (response && response.status) {
          if (response.data.status === 'approved') {
            toast.success(NO_DATA.TARDY_APPROVE);
          }
          if (response.data.status === 'rejected') {
            toast.success(NO_DATA.TARDY_REJECT);
          }

          const getIndex = activityData.findIndex(
            (item) => item._id === param.data?._id
          );
          const userdata = JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_USER_DATA)
          );
          response.data.logs[0].updatedUserName =
            param.data?.activityData?.tardyLogs[0]?.updatedUserName;

          response.data.logs[1].updatedUserName =
            userdata.firstName + (userdata.lastName || '');

          activityData[getIndex].activityData.tardyStatus =
            response.data.status;

          activityData[getIndex].activityData.tardyLogs = response.data.logs;

          activityData[getIndex].activityData.tardyId = response.data._id;

          this.setState({
            activityData,
          });
        }
      })
      .catch((error) => {})
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  calculateCheckinAdherence = (
    shiftStartTime,
    checkinTime,
    totalShiftMinutes
  ) => {
    const shiftStart = moment(shiftStartTime);
    const checkin = moment(checkinTime);

    // Calculate the difference in minutes
    const lateMinutes = checkin.diff(shiftStart, 'minutes');

    const adherence = checkin.isAfter(shiftStart)
      ? (1 - lateMinutes / totalShiftMinutes) * 100
      : 100;

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  calculateCheckoutAdherence = (
    shiftEndTime,
    checkoutTime,
    totalShiftMinutes
  ) => {
    const shiftEnd = moment(shiftEndTime);
    const checkout = moment(checkoutTime);
    // Calculate the difference in minutes

    const adherence = checkout.isBefore(shiftEnd)
      ? (1 - shiftEnd.diff(checkout, 'minutes') / totalShiftMinutes) * 100
      : 100;

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  // Function to calculate the difference in minutes between two time strings
  calculateDifferenceInMinutes = (startTime, endTime) => {
    const start = moment(startTime); // shift time
    const end = moment(endTime);
    // Calculate and return the difference in minutes
    return end.diff(start, 'minutes');
  };

  // Function to calculate shift adherence
  calculateShiftAdherence = (
    shiftStartTime,
    shiftEndTime,
    checkinTime,
    checkoutTime
  ) => {
    const shiftStartTimes = moment(shiftStartTime);
    const shiftEndTimes = moment(shiftEndTime);
    const checkinTimes = moment(checkinTime);
    const checkoutTimes = moment(checkoutTime);
    const setTimes = {
      setStartTimes: checkinTimes,
      setEndTimes: shiftEndTimes,
    };

    // less then shiftStartTimes
    if (checkinTimes.isBefore(shiftStartTimes)) {
      setTimes.setStartTimes = shiftStartTimes;
    }

    if (checkoutTimes.isBefore(shiftEndTimes)) {
      setTimes.setEndTimes = checkoutTimes;
    }

    // Convert shift times and working times into minutes
    let adherenceMinutes = 0;
    if (
      this.calculateDifferenceInMinutes(
        setTimes.setStartTimes,
        setTimes.setEndTimes
      ) > 0
    ) {
      adherenceMinutes = this.calculateDifferenceInMinutes(
        setTimes.setStartTimes,
        setTimes.setEndTimes
      );
    }
    const shiftMinutes = this.calculateDifferenceInMinutes(
      shiftStartTime,
      shiftEndTime
    );

    // Calculate the adherence percentage (working time / shift time)
    const adherence = (adherenceMinutes / shiftMinutes) * 100;
    // Cap adherence at 100% if it exceeds 100%

    return adherence <= 0
      ? `${0}%`
      : `${Math.round(adherence) >= 100 ? 100 : Math.round(adherence)}%`; // Ensuring adherence doesn't go below 0%
  };

  handleSubmitFilter = (params) => {
    const { limit } = this.state;
    const { project, site, teamMember, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.setState({
      initLoad: false,
      project,
      site,
      selectedTeamMember: teamMember,
      status,
      activityData: [],
      timeZone,
      team,
    });
    params.limit = limit;
    this.handleGenerateData(params);
  };

  getClientData = () => {
    const { site } =
      this.liveActivityFormRef &&
      this.liveActivityFormRef.current &&
      this.liveActivityFormRef.current.values;

    this.setState((state) => ({
      ...state,
      isUpdatingClientsList: true,
    }));
    const clientParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: 'active',
      siteId: site,
    };
    if (site.length === 0 || site.includes('all')) {
      delete clientParams.siteId;
    }
    clientsService
      .get_client_list(clientParams)
      .then((clientData) => {
        if (clientData.data) {
          this.setState((state) => ({
            ...state,
            isUpdatingClientsList: false,
            clientsData: [...clientData.data],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingClientsList: false,
        }));
      });
  };

  getMembersAndProjects = () => {
    const { site, clientId } = this.liveActivityFormRef.current.values;
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      siteId: site,
      clientId,
    };
    if (site.length === 0 || site.includes('all')) {
      delete params.siteId;
    }
    if (clientId.length === 0 || clientId.includes('all')) {
      delete params.clientId;
    }
    this.setState({ isUpdatingProjectsList: true, isUpdatingTeamsList: true });
    teamService
      .get_team_members_and_projects(params)
      .then((result) => {
        const { teamMembers, projects, teams } = result.data;
        this.setState((state) => ({
          ...state,
          projectsList: [...projects],
          teamMembersList: [...teamMembers],
          teamGroupList: [...(teams || [])],
          isUpdatingProjectsList: false,
          isUpdatingTeamsList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingProjectsList: false,
          isUpdatingTeamsList: false,
        }));
      });
  };

  handleGenerateData = (formdata, exportType = null) => {
    if (!exportType) {
      this.setState((state) => ({
        ...state,
        isLoading: true,
      }));
    }

    const { permissions } = this.props;
    const { excludeArchivedProjects } = this.liveActivityFormRef.current.values;

    if (
      permissions &&
      permissions.includes('team_member_view') &&
      permissions.includes('others_report_view')
    ) {
      formdata.teamMember = (formdata && formdata.teamMember) || [];
    }

    const { startDate, endDate, page } = this.state;
    const dataFromDate = moment(startDate).format('YYYY-MM-DD');
    const dataToDate = moment(endDate).format('YYYY-MM-DD');
    const params = {
      teamOwnerId: localStorage.getItem(LOCAL_STORAGE_TEAM_OWNER),
      teamMemberId: (formdata && formdata.teamMember) || 'all',
      siteId: (formdata && formdata.site) || [],
      clientId: (formdata && formdata.clientId) || [],
      projectId: (formdata && formdata.project) || [],
      fromDate: dataFromDate.concat(' 00:00:00'),
      toDate: dataToDate.concat(' 23:59:59'),
      page: (formdata && formdata.page) || page,
      status: (formdata && formdata.status) || 'all',
      timeZone: formdata && formdata.timeZone,
      excludeArchivedProjects:
        formdata.excludeArchivedProjects || excludeArchivedProjects,
      teamGroupId: [formdata.team].flat(),
    };
    if (formdata.team === 'all' || !formdata.team) {
      delete params.teamGroupId;
    }
    if (permissions && !permissions.includes('timezone_dropdown_view')) {
      delete params.timeZone;
    }
    if (!exportType) {
      params.limit = (formdata && formdata.limit) || PAGINATION_LIMIT;
    }
    if (
      (formdata.teamMember && formdata.teamMember.length === 0) ||
      (formdata.teamMember && formdata.teamMember.includes('all'))
    ) {
      delete params.teamMemberId;
    }

    if (
      (params.siteId && params.siteId.length === 0) ||
      (params.siteId && params.siteId.includes('all'))
    ) {
      delete params.siteId;
    }

    if (
      (params.clientId && params.clientId.length === 0) ||
      (params.clientId && params.clientId.includes('all'))
    ) {
      delete params.clientId;
    }

    if (
      (params.projectId && params.projectId.length === 0) ||
      (params.projectId && params.projectId.includes('all'))
    ) {
      delete params.projectId;
    }
    if (params.status === 'Early checkout') {
      params.status = 'earlyCheckout';
    }
    if (params.status === 'Late checkin') {
      params.status = 'lateCheckin';
    }
    if (params.status === 'all' || !params.status) {
      delete params.status;
    }

    reportService
      .get_adherence(params)
      .then((response) => {
        if (!exportType) {
          this.setState({ initLoad: true });
        }
        if (response.data) {
          const activitys = response.data.data;
          if (!exportType) {
            const { metadata } = response.data;
            this.setState((state) => ({
              ...state,
              activityData: activitys,
              activityMetadata: metadata,
              isLoading: false,
            }));
          }

          if (exportType === 'excel') {
            this.createExcel(
              activitys.map((item) => {
                item.activityData.teamMemberName = `${
                  item.user.firstName || ''
                } ${item.user.lastName || ''}`;
                return item;
              }),
              params.fromDate,
              params.toDate
            );
          }

          if (exportType === 'pdf') {
            this.createPDF(
              activitys.map((item) => {
                item.activityData.teamMemberName = `${
                  item.user.firstName || ''
                } ${item.user.lastName || ''}`;
                return item;
              }),
              params.fromDate,
              params.toDate
            );
          }
        }
      })
      .catch((error) => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          initLoad: true,
        }));
      });
  };

  handleDateSelect = (event, picker) => {
    picker.element.val(
      `${moment(picker.startDate).format('MMM D, YYYY')} - ${moment(
        picker.endDate
      ).format('MMM D, YYYY')}`
    );
    this.setState((state) => ({
      ...state,
      startDate: moment(picker.startDate),
      endDate: moment(picker.endDate),
    }));
  };

  handleProjectChange = (selelctedProjectList) => {
    this.setState({
      changeSource: 'project',
      project: selelctedProjectList,
    });
  };

  handleSiteChange = (selectedSites) => {
    this.setState({
      site: selectedSites,
      isUpdatingProjectsList: true,
      changeSource: 'site',
    });
  };

  handleClientChange = (selelctedClient) => {
    this.setState({
      clientId: selelctedClient,
      changeSource: 'client',
    });
  };

  handleTeamGroupChange = (e, formikprops) => {
    formikprops.handleChange(e);
    const selectedValue = e.target.value;
    if (selectedValue !== 'all') {
      // Clear Projects
      formikprops.setFieldValue('project', []);
      if (this.projectSelectInputRef?.current?.select) {
        this.projectSelectInputRef.current.select.clearValue();
      }
      // Clear Team Member(s)
      formikprops.setFieldValue('teamMember', []);
      if (this.memberSelectInputRef?.current?.select) {
        this.memberSelectInputRef.current.select.clearValue();
      }
    }
  };

  getMembersWithProject = () => {
    const { site, clientId, project } = this.state;

    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      siteId: site,
      clientId,
    };
    if (project.length > 0) {
      params.projectId = project;
    }
    if (project.length === 0 || project.includes('all')) {
      delete params.projectId;
    }
    if (site.length === 0 || site.includes('all')) {
      delete params.siteId;
    }
    if (clientId.length === 0 || clientId.includes('all')) {
      delete params.clientId;
    }

    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    teamService
      .get_team_members_with_project(params)
      .then((response) => {
        const { members, teams } =
          response && response.data && response.data[0];
        this.setState((state) => ({
          ...state,
          teamMembersList: [...members],
          teamGroupList: [...(teams || [])],
        }));
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  handlePageChange = (page) => {
    const { clientId, selectedTeamMember, limit } = this.state;
    const { project, site, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.setState({
      page,
    });
    this.handleGenerateData({
      page,
      project,
      site,
      clientId,
      teamMember: selectedTeamMember,
      limit,
      timeZone,
      status,
      team,
    });
  };

  handleLimitChange = (newLimitPerPage) => {
    const { clientId, selectedTeamMember } = this.state;

    const { project, site, status, timeZone, team } =
      this.liveActivityFormRef.current.values;

    this.setState({
      limit: newLimitPerPage,
      page: 1,
    });

    this.handleGenerateData({
      limit: newLimitPerPage,
      page: 1,
      project,
      site,
      clientId,
      teamMember: selectedTeamMember,
      initLoad: false,
      timeZone,
      status,
      team,
    });
  };

  export = (exportType) => {
    this.setState({ isLoading: true });
    const { clientId, selectedTeamMember } = this.state;
    const { project, site, status, timeZone, team } =
      this.liveActivityFormRef.current.values;
    this.handleGenerateData(
      {
        page: 1,
        project,
        site,
        clientId,
        teamMember: selectedTeamMember,
        status,
        timeZone,
        team,
      },
      exportType
    );
  };

  createPDF = (activities, startDateTime, endDateTime) => {
    const doc = new JSPDF('landscape', 'pt', 'a3');
    // Set the title of the document
    doc.setFontSize(8);

    // Define the table headers and data
    const tableColumn = [
      'Team Member Name',
      'Email',
      'Employee Id',
      'Site Name',
      'Project Name',
      'Date',
      'Shift Start Time',
      'Checkin Time',
      'Checkin Adherence',
      'Shift End Time',
      'Checkout Time',
      'Checkout Adherence',
      'Shift Time',
      'Total Logged Time',
      'Schedule Adherence',
      'Tardy Status',
    ];
    const tableRows = activities.map((activity) => [
      activity.activityData.teamMemberName || '',
      (activity.user && activity.user.email) || '',
      (activity.user && activity.user.employeeId) || '',
      (activity.activityData && activity.activityData.siteName) || '',
      (activity.activityData &&
        activity.activityData.projectTitle &&
        activity.activityData.projectTitle.toString().replaceAll(',', ', ')) ||
        '',
      `${
        activity.activityData.shiftStart
          ? moment.utc(activity.activityData.shiftStart).format('MMM DD, YYYY')
          : ''
      }`,
      `${
        activity.activityData.shiftStart
          ? moment.utc(activity.activityData.shiftStart).format('hh:mm:ss A')
          : ''
      }`,
      `${
        activity.activityData.checkInDate
          ? moment.utc(activity.activityData.checkInDate).format('hh:mm:ss A')
          : ''
      }`,
      `${
        activity.activityData.shiftStart && activity.activityData.checkInDate
          ? this.calculateCheckinAdherence(
              activity.activityData.shiftStart,
              activity.activityData.checkInDate,
              activity.activityData.shiftDurationMinutes
            )
          : ''
      }`,
      `${
        activity.activityData.shiftEnd
          ? moment.utc(activity.activityData.shiftEnd).format('hh:mm:ss A')
          : ''
      }`,
      `${
        activity.activityData.checkOutDate
          ? moment.utc(activity.activityData.checkOutDate).format('hh:mm:ss A')
          : ''
      }`,
      `${
        activity.activityData.shiftEnd && activity.activityData.checkOutDate
          ? this.calculateCheckoutAdherence(
              activity.activityData.shiftEnd,
              activity.activityData.checkOutDate,
              activity.activityData.shiftDurationMinutes
            )
          : ''
      }`,
      `${
        activity.activityData.shiftDurationMinutes
          ? sToHMSColonSeparated(
              activity.activityData.shiftDurationMinutes * 60
            )
          : ''
      }`,
      `${
        activity.activityData.workSessionMinutes
          ? sToHMSColonSeparated(
              Math.round(activity.activityData.workSessionMinutes * 60)
            )
          : ''
      }`,
      `${
        activity.activityData.shiftStart &&
        activity.activityData.shiftEnd &&
        activity.activityData.checkInDate &&
        activity.activityData.checkOutDate
          ? this.calculateShiftAdherence(
              activity.activityData.shiftStart,
              activity.activityData.shiftEnd,
              activity.activityData.checkInDate,
              activity.activityData.checkOutDate
            )
          : ''
      }`,
      `${
        activity.activityData.tardyStatus
          ? this.capitalizeFirstLetter(activity.activityData.tardyStatus)
          : ''
      }`,
    ]);

    const tableFoot = ['', '', '', ''];
    const totalPagesExp = '{total_pages_count_string}';
    const pageWidth =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    const startDate = moment(startDateTime).format('MMM DD, YYYY');
    const endDate = moment(endDateTime).format('MMM DD, YYYY');
    const attendanceColumnIndex = 9;
    const checkOutVarianceColumnIndex = 8;
    const checkInVarianceColumnIndex = 7;

    // Initialize autoTable
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      foot: [tableFoot],
      startY: 60,
      styles: { cellPadding: 5 },
      margin: { left: 25 }, // Adjust left margin to reduce space
      columnStyles: {
        // Col Width set
        3: { cellWidth: 80 },
        4: { cellWidth: 80 },
        5: { cellWidth: 80 },
        7: { cellWidth: 80 },
        8: { cellWidth: 80 },
        10: { cellWidth: 80 },
        11: { cellWidth: 80 },
      },
      headStyles: {
        fillColor: [237, 242, 249],
        fontSize: 9,
        textColor: [40, 62, 89],
      },
      footStyles: {
        fillColor: [237, 242, 249],
        textColor: [40, 62, 89],
      },
      alternateRowStyles: {
        fillColor: [249, 251, 253],
      },
      tableLineColor: [237, 242, 249],
      tableLineWidth: 1,
      showFoot: 'lastPage',
      didDrawCell: (data) => {
        const { column, cell } = data;

        const columnIndex = column.index;

        if (columnIndex === attendanceColumnIndex) {
          const value = cell.raw || '';

          if (value === 'Absent') {
            doc.setTextColor(255, 0, 0); // Red color for negative values
            doc.text(value, cell.x + 5, cell.y + 13.2);
          } else if (value === 'Present') {
            doc.setTextColor(0, 128, 0); // Green color for positive values
            doc.text(value, cell.x + 5, cell.y + 13.2);
          } else if (value === 'Late') {
            doc.setTextColor(255, 165, 0); // Green color for positive values
            doc.text(value, cell.x + 5, cell.y + 13.2);
          }
        }

        if (columnIndex === checkInVarianceColumnIndex) {
          const value = cell.raw || '';
          if (value.includes('Early login')) {
            doc.setTextColor(0, 128, 0); // Green color for positive values
            doc.text(value, cell.x + 5, cell.y + 13.2, {
              maxWidth: cell.width - 5,
            });
          } else if (value.includes('Late login')) {
            doc.setTextColor(255, 0, 0); // Red color for negative values
            doc.text(value, cell.x + 5, cell.y + 13.2, {
              maxWidth: cell.width - 5,
            });
          }
        }

        if (columnIndex === checkOutVarianceColumnIndex) {
          const value = cell.raw || '';

          if (value.includes('Late logout')) {
            doc.setTextColor(0, 128, 0); // Green color for positive values
            doc.text(value, cell.x + 5, cell.y + 13.2, {
              maxWidth: cell.width - 5,
            });
          } else if (value.includes('Early logout')) {
            doc.setTextColor(255, 0, 0); // red color for positive values
            doc.text(value, cell.x + 5, cell.y + 13.2, {
              maxWidth: cell.width - 5,
            });
          }
        }
      },
      didDrawPage() {
        // Header
        doc.setFontSize(12);
        doc.setTextColor(40);
        doc.text('Adherence Report', pageWidth / 2, 23, 'center');
        doc.setFontSize(10);
        doc.text(
          `Date Range : ${startDate} - ${endDate}`,
          pageWidth / 2,
          38,
          'center'
        );

        // Footer
        let str = `Page ${doc.internal.getNumberOfPages()}`;
        // Total page number
        if (typeof doc.putTotalPages === 'function') {
          str = `${str} of ${totalPagesExp}`;
        }
        doc.setFontSize(9);
        const { pageSize } = doc.internal;
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, 750, pageHeight - 22);
      },
    });
    // Total page number
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }
    // Save the generated PDF
    doc.save(
      `Adherence_report–(${moment(startDateTime).format(
        'MMM-DD-YYYY'
      )}-${moment(endDateTime).format('MMM-DD-YYYY')}).pdf`
    );
    this.setState({ isLoading: false });
  };

  capitalizeFirstLetter = (val) =>
    String(val).charAt(0).toUpperCase() + String(val).slice(1);

  createExcel = async (activities, startDateTime, endDateTime) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Define headers for the columns
    const headers = [
      'Team Member Name',
      'Email',
      'Employee Id',
      'Site',
      'Project Name',
      'Date',
      'Shift Start Time',
      'Checkin Time',
      'Checkin Adherence',
      'Shift End Time',
      'Checkout Time',
      'Checkout Adherence',
      'Shift Time',
      'Total Logged Time',
      'Schedule Adherence',
      'Tardy Status',
    ];

    // Create worksheet rows start
    const worksheetData = [
      [`Adherence Report`], // Title in the first row
      headers, // Headers in the second row
    ];

    // Add the activities data after the header row
    activities.forEach((activity) => {
      worksheetData.push([
        activity.activityData.teamMemberName || '',
        (activity.user && activity.user.email) || '',
        (activity.user && activity.user.employeeId) || '',
        (activity.activityData && activity.activityData.siteName) || '',
        (activity.activityData &&
          activity.activityData.projectTitle &&
          activity.activityData.projectTitle
            .toString()
            .replaceAll(',', ', ')) ||
          '',
        `${
          activity.activityData.shiftStart
            ? moment
                .utc(activity.activityData.shiftStart)
                .format('MMM DD, YYYY')
            : ''
        }`,
        `${
          activity.activityData.shiftStart
            ? moment.utc(activity.activityData.shiftStart).format('hh:mm:ss A')
            : ''
        }`,
        `${
          activity.activityData.checkInDate
            ? moment.utc(activity.activityData.checkInDate).format('hh:mm:ss A')
            : ''
        }`,
        `${
          activity.activityData.shiftStart && activity.activityData.checkInDate
            ? this.calculateCheckinAdherence(
                activity.activityData.shiftStart,
                activity.activityData.checkInDate,
                activity.activityData.shiftDurationMinutes
              )
            : ''
        }`,
        `${
          activity.activityData.shiftEnd
            ? moment.utc(activity.activityData.shiftEnd).format('hh:mm:ss A')
            : ''
        }`,
        `${
          activity.activityData.checkOutDate
            ? moment
                .utc(activity.activityData.checkOutDate)
                .format('hh:mm:ss A')
            : ''
        }`,
        `${
          activity.activityData.shiftEnd && activity.activityData.checkOutDate
            ? this.calculateCheckoutAdherence(
                activity.activityData.shiftEnd,
                activity.activityData.checkOutDate,
                activity.activityData.shiftDurationMinutes
              )
            : ''
        }`,
        `${
          activity.activityData.shiftDurationMinutes
            ? sToHMSColonSeparated(
                activity.activityData.shiftDurationMinutes * 60
              )
            : ''
        }`,
        `${
          activity.activityData.workSessionMinutes
            ? sToHMSColonSeparated(
                Math.round(activity.activityData.workSessionMinutes * 60)
              )
            : ''
        }`,
        `${
          activity.activityData.shiftStart &&
          activity.activityData.shiftEnd &&
          activity.activityData.checkInDate &&
          activity.activityData.checkOutDate
            ? this.calculateShiftAdherence(
                activity.activityData.shiftStart,
                activity.activityData.shiftEnd,
                activity.activityData.checkInDate,
                activity.activityData.checkOutDate
              )
            : ''
        }`,
        `${
          activity.activityData.tardyStatus
            ? this.capitalizeFirstLetter(activity.activityData.tardyStatus)
            : ''
        }`,
      ]);
    });

    // Convert to worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Set merged title header (first row)
    worksheet['!merges'] = [
      {
        s: { r: 0, c: 0 }, // Start cell A1
        e: { r: 0, c: headers.length - 1 }, // End cell N1
      },
    ];
    worksheet.A1 = {
      v: `Adherence Report – (${moment(startDateTime).format(
        'MMM DD, YYYY'
      )} - ${moment(endDateTime).format('MMM DD, YYYY')})`,
    };

    // Styling for the merged title header
    worksheet.A1.s = {
      font: { bold: true, sz: 12, color: { rgb: '000000' } }, // Black text color
      fill: { patternType: 'solid', fgColor: { rgb: 'FFFFFF' } }, // White background
      alignment: { horizontal: 'center', vertical: 'middle' },
      border: {
        top: { style: 'thin', color: { rgb: '000000' } }, // Border around the merged cell
        left: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
      },
    };

    // Style the header row (Row 2)
    const headerRowIndex = 1; // Row 2 after the merged title

    headers.forEach((header, col) => {
      const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: col });
      worksheet[cellAddress].s = {
        font: { bold: true, sz: 11, color: { rgb: 'FFFFFF' } },
        fill: {
          patternType: 'solid',
          fgColor: { rgb: '729FCF' },
        },
        alignment: { horizontal: 'center' },
        border: {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        },
      };
    });

    // rows and apply conditional formatting
    worksheetData.slice(2).forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({
          r: rowIndex + 2,
          c: colIndex,
        });
        // Apply color formatting based on conditions
        if (colIndex === 7) {
          // Check-out Variance
          if (cell.includes('Early login')) {
            worksheet[cellAddress].s = { font: { color: { rgb: '00FF00' } } }; // Green
          } else if (cell.includes('Late login')) {
            worksheet[cellAddress].s = { font: { color: { rgb: 'FF0000' } } }; // Red
          }
        }
        if (colIndex === 8) {
          // Check-out Variance
          if (cell.includes('Late logout')) {
            worksheet[cellAddress].s = { font: { color: { rgb: '00FF00' } } }; // Green
          } else if (cell.includes('Early logout')) {
            worksheet[cellAddress].s = { font: { color: { rgb: 'FF0000' } } }; // Red
          }
        }
        if (colIndex === 9) {
          // Attendance Status
          if (cell === 'Present') {
            worksheet[cellAddress].s = { font: { color: { rgb: '00FF00' } } }; // Green
          } else if (cell === 'Absent') {
            worksheet[cellAddress].s = { font: { color: { rgb: 'FF0000' } } }; // Red
          } else if (cell === 'Late') {
            worksheet[cellAddress].s = { font: { color: { rgb: 'F59C17' } } }; // Yellow
          }
        }

        // Styling for data rows (default font size and border)
        worksheet[cellAddress].s = worksheet[cellAddress].s || {};
        worksheet[cellAddress].s.font = worksheet[cellAddress].s.font || {
          size: 10,
        };
        worksheet[cellAddress].s.border = worksheet[cellAddress].s.border || {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
      });
    });

    // Append worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Write the Excel file and trigger download
    const fileName = `Adherence_report–(${moment(startDateTime).format(
      'MMM-DD-YYYY'
    )}-${moment(endDateTime).format('MMM-DD-YYYY')}).xlsx`;
    XLSX.writeFile(workbook, fileName);
    this.setState({ isLoading: false });
  };

  render() {
    const {
      teamMembersList,
      startDate,
      endDate,
      activityData,
      activityMetadata,
      isLoading,
      numberOfDaysSelected,
      daysLimit,
      projectsList,
      isUpdatingProjectsList,
      isUpdatingTeamsList,
      isUpdatingClientsList,
      limit,
      initLoad,
      timeZone,
      clientsData,
      teamGroupList,
    } = this.state;
    const { hierarchy, permissions } = this.props;
    // Team owner ID
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    const data = [];
    activityData.forEach((activity, index) => {
      data.push({
        id: `tm${index}`,
        teamMemberName: `${activity.user.firstName} ${
          activity.user.lastName || ''
        }`,
        email: activity.user.email || '',
        employeeId: activity.user.employeeId || '',
        siteName: `${activity.activityData.siteName || ''}`,
        projectName: `${
          activity.activityData.projectTitle.toString().replaceAll(',', ', ') ||
          ''
        }`,
        date: `${moment
          .utc(activity.activityData.shiftStart)
          .format('MMM DD, YYYY')}`,
        shiftStartTime: (
          <div>
            {`${
              activity.activityData.shiftStart
                ? moment
                    .utc(activity.activityData.shiftStart)
                    .format('hh:mm:ss A')
                : ''
            }`}
          </div>
        ),
        checkinTime: (
          <div>
            {activity.activityData.checkInDate &&
            activity.activityData.checkInDate !== null
              ? moment
                  .utc(activity.activityData.checkInDate)
                  .format('hh:mm:ss A')
              : ''}
          </div>
        ),
        checkinAdherence: (
          <div>
            {activity.activityData.shiftStart &&
            activity.activityData.checkInDate
              ? `${this.calculateCheckinAdherence(
                  activity.activityData.shiftStart,
                  activity.activityData.checkInDate,
                  activity.activityData.shiftDurationMinutes
                )}`
              : ''}
          </div>
        ),
        shiftEndTime: (
          <div>
            {`${
              activity.activityData.shiftEnd
                ? moment
                    .utc(activity.activityData.shiftEnd)
                    .format('hh:mm:ss A')
                : ''
            }`}
          </div>
        ),
        checkoutTime: (
          <div>
            {activity.activityData.checkOutDate &&
            activity.activityData.checkOutDate !== null
              ? moment
                  .utc(activity.activityData.checkOutDate)
                  .format('hh:mm:ss A')
              : ''}
          </div>
        ),
        checkoutAdherence: (
          <div>
            {activity.activityData.shiftEnd &&
            activity.activityData.checkOutDate
              ? this.calculateCheckoutAdherence(
                  activity.activityData.shiftEnd,
                  activity.activityData.checkOutDate,
                  activity.activityData.shiftDurationMinutes
                )
              : ''}
          </div>
        ),
        shiftTime: (
          <div>
            {activity.activityData.shiftDurationMinutes
              ? sToHMSColonSeparated(
                  activity.activityData.shiftDurationMinutes * 60
                )
              : ''}
          </div>
        ),
        totalWorkingTime: (
          <div>
            {activity.activityData.workSessionMinutes
              ? sToHMSColonSeparated(
                  Math.round(activity.activityData.workSessionMinutes * 60)
                )
              : ''}
          </div>
        ),
        shiftAdherence: (
          <div>
            {activity.activityData.shiftStart &&
            activity.activityData.shiftEnd &&
            activity.activityData.checkInDate &&
            activity.activityData.checkOutDate
              ? this.calculateShiftAdherence(
                  activity.activityData.shiftStart,
                  activity.activityData.shiftEnd,
                  activity.activityData.checkInDate,
                  activity.activityData.checkOutDate
                )
              : ''}
          </div>
        ),
        ...(permissions &&
          (permissions.includes('tardy_request') ||
            permissions.includes('tardy_approval')) &&
          activity.activityData.tardyDisplay && {
            tardy: (
              <Tardy
                data={activity}
                sendRequest={this.handleTardyRequest}
                tardyApproval={this.handleTardyApproval}
              />
            ),
          }),
      });
    });

    return (
      <Layout pageHeading={this.pageHeading}>
        <Formik
          initialValues={{
            teamOwnerId,
            site: [],
            clientId: [],
            team: 'all',
            project: [],
            teamMember: [],
            status: 'all',
            fromDate: startDate,
            toDate: endDate,
            page: 1,
            limit: limit || PAGINATION_LIMIT,
            timeZone,
            excludeArchivedProjects: true,
          }}
          onSubmit={(values) => {
            this.handleSubmitFilter(values);
          }}
          innerRef={this.liveActivityFormRef}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit} className="mb-5">
              <Row>
                {hierarchy?.sites?.length > 0 && (
                  <Col md={6} lg={3}>
                    <MultiSelectItemDropdown
                      id="siteSelectInputRef"
                      name="site"
                      labelText="Sites"
                      fromArray={hierarchy.sites.map((site) => ({
                        value: site._id,
                        label: site.siteName,
                      }))}
                      formProps={formikprops}
                      isDisabled={hierarchy.sites.length < 1 && true}
                      innerRef={this.siteSelectInputRef}
                      isAllItemOption
                      isAllItemValuesWithNoArray
                      showErrorMessage
                      onChangeAction={this.handleSiteChange}
                    />
                  </Col>
                )}
                {permissions &&
                  permissions.includes('client_manage') &&
                  clientsData?.length > 0 && (
                    <Col md={6} lg={3}>
                      <MultiSelectItemDropdown
                        id="clientSelectInputRef"
                        name="clientId"
                        labelText="Clients"
                        fromArray={clientsData.map((client) => ({
                          value: client._id,
                          label: client.name,
                        }))}
                        formProps={formikprops}
                        isDisabled={clientsData.length < 1 && true}
                        innerRef={this.clientSelectInputRef}
                        isAllItemOption
                        isAllItemValuesWithNoArray
                        showErrorMessage
                        onChangeAction={this.handleClientChange}
                      />
                    </Col>
                  )}
                {permissions && permissions.includes('team_member_view') && (
                  <Col md={6} lg={3}>
                    <Form.Group controlId="team">
                      <Form.Label>Team Group</Form.Label>
                      <Field
                        className="form-select"
                        as="select"
                        name="team"
                        onChange={(e) => {
                          this.handleTeamGroupChange(e, formikprops);
                        }}
                      >
                        <option value="all">All</option>
                        {teamGroupList &&
                          teamGroupList.length > 0 &&
                          teamGroupList.map((teamGroup, index) => (
                            <option
                              key={`teamGroup${index}`}
                              value={teamGroup._id}
                            >
                              {teamGroup.name}
                            </option>
                          ))}
                      </Field>
                    </Form.Group>
                  </Col>
                )}
                <Col md={6} lg={3}>
                  <MultiSelectItemDropdown
                    id="projectSelectInputRef"
                    name="project"
                    labelText="Projects"
                    fromArray={projectsList.map((project) => ({
                      value: project._id,
                      label: project.title,
                    }))}
                    formProps={formikprops}
                    isDisabled={
                      formikprops.values.team !== 'all' ||
                      (projectsList.length < 1 && true)
                    }
                    innerRef={this.projectSelectInputRef}
                    isAllItemOption
                    isAllItemValuesWithNoArray
                    showErrorMessage
                    onChangeAction={this.handleProjectChange}
                  />
                </Col>
                {permissions &&
                  permissions?.includes('team_member_view') &&
                  permissions?.includes('others_report_view') && (
                    <Col md={6} lg={3}>
                      <MemberMultiSelectDropdown
                        id="memberSelectInputRef"
                        name="teamMember"
                        labelText="Team Member(s)"
                        fromArray={teamMembersList}
                        formProps={formikprops}
                        isDisabled={
                          formikprops.values.team !== 'all' ||
                          (teamMembersList.length < 1 && true)
                        }
                        innerRef={this.memberSelectInputRef}
                        isAllTeamMemberOption
                        isAllTeamMemberValuesWithNoArray
                        requiredValueAs="userId"
                        showErrorMessage
                      />
                    </Col>
                  )}

                <Col md={6} lg={3}>
                  <Form.Group>
                    <Form.Label>Date range</Form.Label>
                    <DateRangePicker
                      onEvent={this.handleDateSelect}
                      initialSettings={{
                        autoUpdateInput: false,
                        singleDatePicker: false,
                        startDate: moment().toDate(),
                        locale: {
                          format: 'MMM D, YYYY',
                        },
                        alwaysShowCalendars: true,
                        autoApply: true,
                      }}
                    >
                      <input
                        type="text"
                        className="form-control icon-calendar"
                        placeholder={`${moment().format(
                          'MMM D, YYYY'
                        )} - ${moment().format('MMM D, YYYY')}`}
                      />
                    </DateRangePicker>
                  </Form.Group>
                </Col>
                {permissions &&
                  permissions.includes('timezone_dropdown_view') && (
                    <Col md={6} lg={3}>
                      <Form.Group controlId="Timezone">
                        <Form.Label>Timezone</Form.Label>
                        <TimeZoneDropdown
                          timeZoneName="timeZone"
                          formik={formikprops}
                          defaultValue={timeZone}
                        />
                      </Form.Group>
                    </Col>
                  )}
                <Col md={6} lg={3}>
                  <StatusDropdown
                    statusList={[
                      { statusName: 'Early checkout' },
                      { statusName: 'Late checkin' },
                    ]}
                    handleChange={formikprops.handleChange}
                  />
                </Col>
                <Col xs={12}>
                  <Form.Group controlId="excludeArchivedProjects">
                    <Form.Check
                      name="excludeArchivedProjects"
                      type="checkbox"
                      label="Exclude archived projects"
                      checked={formikprops.values.excludeArchivedProjects}
                      className="pt-3"
                      onChange={() =>
                        formikprops.setFieldValue(
                          'excludeArchivedProjects',
                          !formikprops.values.excludeArchivedProjects
                        )
                      }
                    />
                  </Form.Group>
                  <Form.Group controlId="generateData">
                    <div>
                      <Button
                        variant="primary"
                        type="Submit"
                        disabled={numberOfDaysSelected > daysLimit}
                      >
                        Generate
                      </Button>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
        <Card style={{ marginBottom: '0px !important' }}>
          <Card.Header>
            <Row className="align-items-center my-3">
              <Col>
                <div className="card-title h4 m-0">
                  {this.pageHeading.title}
                </div>
              </Col>

              {data && data.length > 0 && (
                <Col xs="auto" className="ml-auto">
                  Download as{' '}
                  <Button
                    variant="white"
                    type="button"
                    size="sm"
                    className="mx-1"
                    disabled={numberOfDaysSelected > daysLimit}
                    onClick={() => {
                      this.export('excel');
                    }}
                  >
                    Excel
                  </Button>
                  <Button
                    variant="white"
                    type="button"
                    size="sm"
                    className="mx-1"
                    onClick={() => {
                      this.export('pdf');
                    }}
                  >
                    PDF
                  </Button>
                </Col>
              )}
            </Row>
          </Card.Header>

          <div className="text-muted">
            {initLoad && (
              <AdherenceDataTable
                isLoading={isLoading}
                totalRows={activityMetadata.total}
                projectsData={data}
                perPage={activityMetadata.limit}
                handlePageChange={this.handlePageChange}
                handleLimitChange={this.handleLimitChange}
              />
            )}
          </div>
        </Card>
        <br />
        {/* Loader */}
        {(isLoading ||
          isUpdatingProjectsList ||
          isUpdatingTeamsList ||
          isUpdatingClientsList) && <Loading contentAreaOnly />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { hierarchy, permissionsReducer } = state;
  return {
    hierarchy,
    permissions: permissionsReducer,
  };
};

MemberLiveActivity.propTypes = {
  hierarchy: PropTypes.object,
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(MemberLiveActivity);
